import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  min-height: 23rem;
  padding: 4rem 5rem;
  text-align: center;
  width: 40rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0;
  }

  .button-container {
    width: 100%;
  }

  .description {
    ${(props) => `
      color: ${props.theme.colors.gray};
    `}
    font-size: 1.5rem;
  }

  .icon {
    height: 6rem;
    margin: 1rem;
    width: 6rem;
  }
`;
interface IButton {
  status?: string;
}
export const Button = styled.button<IButton>`
  ${(props) => `
    background-color: ${
      props.status === "accept"
        ? props.theme.colors.primaryBlue
        : props.status === "confirm"
        ? props.theme.colors.accentRed
        : props.theme.colors.white
    };
    border: ${
      props.status === "cancel"
        ? `1px solid ${props.theme.colors.accentRed}`
        : "none"
    };
    color: ${
      props.status === "cancel"
        ? props.theme.colors.accentRed
        : props.theme.colors.white
    };
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-top: 1rem;
  width: 100%;

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;
